import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{class:_setup.props.content_class,attrs:{"color":"primary","small":""},on:{"click":_setup.exportarPedido}},[_vm._v("\n  Exportação Automatiza\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }